import { HttpErrorResponse, HttpHeaders, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { tap } from 'rxjs';

const refreshedTokenHeader = 'X-Ringo-Refreshed-Token';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = localStorage.getItem('token');
  const authorizedRequest = token
    ? req.clone({
        setHeaders: { Authorization: token }
      })
    : req;

  return next(authorizedRequest).pipe(
    tap({
      next: event => {
        if (event instanceof HttpResponse) {
          storeRefreshedToken(event.headers);
        }
      },
      error: error => {
        if (error instanceof HttpErrorResponse) {
          storeRefreshedToken(error.headers);
        }
      }
    })
  );
};

function storeRefreshedToken(headers: HttpHeaders): void {
  const refreshedToken = headers.get(refreshedTokenHeader);
  if (refreshedToken?.startsWith('Bearer ') && refreshedToken.length > 7) {
    localStorage.setItem('token', refreshedToken);
  }
}
